// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3xORj","label":"SetPasswdForm_label__2MTx1"};